import { ICustoEncarregado } from "../../../Interfaces/AssistenciaTecnica/CustoEncarregadoRelatorioBI/CustoEncarregadoRelatorioBIInterface";
import {
    AtualizacaoDeCustoEncarregadoService,
    CadastroDeCustoEncarregadoService,
    getCustoEncarregadoService,
    ListagemDeCustoEncarregadoService,
    RemocaoDeCustoEncarregadoService,
} from "../../../Services/AssistenciaTecnica/CustoEncarregadoRelatorioBI/CustoEncarregadoRelatorioBIService";
import { Controller } from "../../Controller";

export async function CadastroDeCustoEncarregadoController(
    requestBody: ICustoEncarregado
) {
    return Controller(CadastroDeCustoEncarregadoService(requestBody));
}

export async function getCustoEncarregadoController(ID_CUSTO: number) {
    return Controller(getCustoEncarregadoService(ID_CUSTO));
}

export async function ListagemDeCustoEncarregadoController() {
    return Controller(ListagemDeCustoEncarregadoService());
}

export async function AtualizacaoDeCustoEncarregadoController(
    requestBody: Array<ICustoEncarregado>
) {
    return Controller(AtualizacaoDeCustoEncarregadoService(requestBody));
}

export async function RemocaoDeCustoEncarregadoController(ID: number) {
    return Controller(RemocaoDeCustoEncarregadoService(ID));
}
